/**
 * Transforms nested bracket notation to chained bracket notation for Rails 8
 *
 * Rails 8 changed how formdata keys are parsed. Keys must use chained brackets
 * instead of nested brackets.
 *
 * @example "a[b[c[d]]]" → "a[b][c][d]"
 * @example "incidents[1[date]]" → "incidents[1][date]"
 * @example "customer[name[forename]]" → "customer[name][forename]"
 */
export const transformBracketsForRails = (key: string): string => {
  let result = key;
  let replacementCount = 0;

  // Replace [text[ with [text][ repeatedly until no more nested brackets
  while (true) {
    const newResult = result.replace(/\[([^[\]]+)\[/, "[$1][");
    if (newResult === result) break;
    result = newResult;
    replacementCount++;
  }

  // Remove the extra trailing brackets created by the replacements
  if (replacementCount > 0) {
    result = result.slice(0, -replacementCount);
  }

  return result;
};
